import { Fragment } from 'vue-fragment';
import { mapMutations, mapGetters } from 'vuex';
import CasaBreadcrumbs from '@/components/CasaBreadcrumbs.vue';
export default {
    props: {
        elements: Array,
        isOnProduct: Boolean,
        isPageAllowed: Boolean,
        default: () => true,

        // We can't use v-show directive on the component due to framgent issues with v-show.
        // This is a workaround to hide the component when needed.
        show: {
            type: Boolean,
            default: () => true,
        },
    },
    computed: {
        ...mapGetters({
            isFarmacie: 'global/getIsFarmacie',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            globalSettings: 'global/globalSettings',
        }),
        lastIndex() {
            return this.elements?.length - 1;
        },
    },
    methods: {
        ...mapMutations('product', ['setLinkCopiedNotification']),
        goBack() {
            this.$router.go(-1);
        },
        copyLink() {
            this.setLinkCopiedNotification(true);
            navigator.clipboard.writeText(window.location.href);
        },
    },
};
